module.exports = __webpack_public_path__ + "static/media/cross-orange.226173e6.svg";